import * as React from "react";
import type { GatsbyBrowser } from "gatsby";
import { WrapRootElement } from "./src/provider";

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => (
   <WrapRootElement element={element} />
)

// gatsby-plugin-google-gtag раньше присылал page_view при каждом клиентском
// переходе сам (initial-конфиг gtag шлёт send_page_view:false именно ради
// этого — чтобы не задвоить событие). Partytown даёт window.gtag как прокси
// в основном потоке (см. forward в gatsby-config.ts), так что вызов работает
// точно так же, просто без самого плагина.
export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location }) => {
  if (process.env.NODE_ENV !== "production" || typeof (window as any).gtag !== "function") return

  const sendPageView = () => {
    const pagePath = location ? location.pathname + location.search + location.hash : undefined
    ;(window as any).gtag("event", "page_view", { page_path: pagePath })
  }

  if ("requestAnimationFrame" in window) {
    requestAnimationFrame(() => requestAnimationFrame(() => setTimeout(sendPageView, 0)))
  } else {
    setTimeout(sendPageView, 32)
  }
}